<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationProfessionalRegisterForm v-if="iamsmartSession == null" :info="info" :businessId="businessId"/>
      <ERegistrationProfessionalRegisterIAmSmartForm v-else :info="info" :businessId="businessId" :iamsmartSession="iamsmartSession"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalRegisterForm from "../components/e-registration-professional-register/ERegistrationProfessionalRegisterForm";
import ERegistrationProfessionalRegisterIAmSmartForm from "../components/e-registration-professional-register-iamsmart/ERegistrationProfessionalRegisterIAmSmartForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo";
import { IAmSmartQrCodeApi } from '@/api';

export default {
  props: ["info", "businessId"],
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationProfessionalRegisterForm,
    ERegistrationProfessionalRegisterIAmSmartForm
  },
  async beforeRouteEnter(to, from, next) {
    if (!to.params.info) {
      next({ name: "ERegistrationProfessionalActivate" });
      
    } else{ 
      console.log("params",to.params.businessId);
      const  businessId = to.params.businessId;
      
      
      if (businessId) {
        console.log("iamsmart 1 ", businessId);
        const iamsmartSession = await IAmSmartQrCodeApi.getSession(businessId);
        console.log("iamsmart 2", iamsmartSession.data);
        next((vm) => {
          console.log("iamsmart", iamsmartSession.data);
          vm.iamsmartSession = iamsmartSession.data;
        });
      } else {
        next();
      }
    }
  },
  data() {
    return {
      iamsmartSession: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
